<template>
  <div class="fee">
    <i18n
      path="fee.amount"
      tag="p"
      class="fee-amount"
    >
      <template v-slot:amount>
        {{
          (feeAmount / 100).toLocaleString($localeString, {
            style: "currency",
            currency: currency,
          })
        }}
      </template>
      <template v-slot:icon>
        <i
          class="el-icon-info fee-amount__icon"
          @click="toggleDialog"
        />
      </template>
    </i18n>
    <el-checkbox
      class="fee-checkbox"
      v-model="payFee"
      :style="{ '--schema-color': primaryColor }"
    >
      <i18n path="fee.checkbox">
        <template v-slot:nickname>
          {{ paymentFor }}
        </template>
        <i
          class="el-icon-info fee-amount__icon"
          @click="toggleDialog"
        />
      </i18n>
    </el-checkbox>
    <el-dialog
      :visible.sync="showDialog"
      width="400px"
      :center="true"
      :show-close="false"
      class="fee-dialog"
    >
      <p class="fee-dialog__text">
        {{ $t("fee.dialog-text") }}
      </p>
      <el-button
        type="primary"
        class="primary-button"
        @click="toggleDialog"
        :style="{
          background: primaryColor,
        }"
      >
        {{ $t("fee.dialog-button") }}
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "FeeCheckbox",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    feePercentage: {
      type: Number,
      default: 500,
    },
    currency: {
      type: String,
      default: "EUR",
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    feeAmount: {
      type: Number,
      default: 0,
    },
    paymentFor: {
      type: String,
      default: "",
    },
    strategy: {
      type: Object,
      default: function() {
        return {};
      },
    },
    primaryColor: {
      type: String,
      default: "#FF8A00",
    },
  },
  data: () => ({
    showDialog: false,
  }),
  created() {
    this.strategy.setAmount(this.totalAmount);
    this.$emit("update:feeAmount", this.strategy.calculateFee());
  },
  watch: {
    totalAmount(amount) {
      this.strategy.setAmount(amount);
      this.$emit("update:feeAmount", this.strategy.calculateFee());
    },
  },
  computed: {
    payFee: {
      get: function() {
        return this.value;
      },
      set: function(value) {
        this.$emit("change", value);
      },
    },
  },
  methods: {
    toggleDialog: function() {
      this.showDialog = !this.showDialog;
    },
  },
};
</script>
<style lang="scss">
.fee {
  .el-checkbox__inner:hover {
    border-color: var(--schema-color);
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: var(--schema-color);
  }

  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: var(--schema-color);
  }

  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--schema-color);
    border-color: var(--schema-color);
  }
}
</style>
<style lang="scss" scoped>
.fee {
  width: 100%;
  text-align: center;
  margin: 10px auto 0 auto;

  &-amount {
    font-family: "Raleway Medium", serif;
    font-size: 16px;
    margin: 0;

    &__icon {
      cursor: pointer;
    }
  }

  &-checkbox::v-deep {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-family: "Raleway Regular", serif;
    font-size: 16px;

    .el-checkbox__label {
      white-space: normal;
      text-align: left;
      margin-right: 5px;
    }
  }

  &-dialog {
    &__text {
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      word-break: break-word;
    }
  }
}
</style>
